{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPI} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/toolbar';
import Anatomy from '/packages/dev/s2-docs/pages/react-aria/ToolbarAnatomy.svg';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a toolbar component.';
export const isSubpage = true;

# useToolbar

<PageDescription>{docs.exports.useToolbar.description}</PageDescription>

```tsx render files={["starters/hooks/src/Toolbar.tsx", "starters/hooks/src/Toolbar.css", "starters/hooks/src/Button.tsx", "starters/hooks/src/Button.css"]}
"use client";
import {Toolbar} from 'hooks-starter/Toolbar';
import {Button} from 'hooks-starter/Button';

<Toolbar aria-label="Actions">
  <Button variant="secondary">Copy</Button>
  <Button variant="secondary">Cut</Button>
  <Button variant="secondary">Paste</Button>
</Toolbar>
```

## API

<Anatomy />

```tsx
<Toolbar>
  <Button />
  <ToggleButtonGroup>
    <ToggleButton />
  </ToggleButtonGroup>
  <Separator />
  <Group>
    <Button />
  </Group>
  <Select />
</Toolbar>
```

<FunctionAPI function={docs.exports.useToolbar} links={docs.links} />

### AriaToolbarProps

<InterfaceType {...docs.exports.AriaToolbarProps} />

### ToolbarAria

<InterfaceType {...docs.exports.ToolbarAria} />
